<template>
  <div class="p">
    <el-row>
      <el-col :span="24">
        <img class="banner" src="@/assets/images/product2.png" alt=""
      /></el-col>
    </el-row>
    <div class="main">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="9" :md="9">
          <div class="toptxt">
            <h1>居家健康检测平台</h1>
            <img src="@/assets/images/ge.png" alt="" />
            <p>清华博士团队首创研发，智能硬件+医疗器械软件+体外诊断试剂，构成一套医疗级的定量检测系统。发明专利号：ZL2020115542198。</p>
          </div></el-col
        >
        <el-col class="pdt">
          <div class="product">
            <a href="" @click="handleGo('/product/lh')">
              <div class="pic">
                <img src="@/assets/images/f2-2.png" alt="" />
              </div>
              <div class="txt">
                <h3>智能免疫层析定量一体机</h3>
                <p>
                  <span>了解更多>></span>
                </p>
              </div>
              <div class="mask"></div>
            </a></div
        ></el-col>
      </el-row>


      <el-row type="flex" justify="center">
        <el-col :xs="23" :sm="14" class="ge"></el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="9" :md="9">
          <div class="toptxt first">
            <h1>女性健康检测系列</h1>
            <img src="@/assets/images/ge.png" alt="" />
            <p>
              基于前沿免疫学技术、光机电技术与中国人的大数据，以预防性检测的健康管理为首要目标，研发全球领先的专为家庭和个人设计的微创、超敏检测平台。从精准定量检测入手，服务于中国女性的全周期健康管理事业。发明专利号：ZL201610634942.4
              。
            </p>
          </div></el-col
        >
        <el-col class="pdt">
          <div class="product">
            <a href="" @click="handleGo('/product/amh')">
              <div class="pic">
                <img src="@/assets/images/f6.png" alt="" />
              </div>
              <div class="txt">
                <h3>一滴血卵巢功能检测(AMH测定)</h3>
                <p>
                  <span>了解更多>></span>
                </p>
              </div>
              <div class="mask"></div>
            </a></div
        ></el-col>
      </el-row>


      <el-row type="flex" justify="center">
        <el-col :xs="23" :sm="14" class="ge"></el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="9" :md="9">
          <div class="toptxt">
            <h1>家庭健康监测系列</h1>
            <img src="@/assets/images/ge.png" alt="" />
            <p>
              度芽智能体温贴，体温计中的黑科技。专为0-6岁婴幼儿设计，一款可24H实时监测、高低温报警、远程共享的智能体温贴。作为新一代超柔超薄超轻的智能体温监测工具,在宝宝发烧时，为家庭提供安心解决方案。
            </p>
          </div></el-col
        >
        <el-col class="pdt">
          <div class="product">
            <a href="" @click="handleGo('/product/twt')">
              <div class="pic">
                <img src="@/assets/images/f1.png" alt="" />
              </div>
              <div class="txt">
                <h3>儿童智能体温贴</h3>
                <p>
                  <span>了解更多>></span>
                </p>
              </div>
              <div class="mask"></div>
            </a></div
        ></el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {};
  },
  methods: {
    handleGo(target) {
      this.$router.push(target);
    },
  },
};
</script>

<style lang="less" scoped>
.pdt {
  width: 370px;
}
.main {
  margin-top: 20px;
}
.el-row {
  flex-wrap: wrap;
}
.toptxt {
  margin: 10px;
  p {
    margin-top: 10px;
  }
}

.ge {
  margin: 30px 0;
  height: 2px;
  background-color: rgb(206, 206, 206);
}

.product .txt {
  line-height: 30px;
  text-align: center;
  margin-bottom: 30px;
}
.mask {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 300px;
  width: 400px;
  background-image: linear-gradient(
    transparent 70%,
    rgba(100, 16, 173, 0.5) 30%
  );
  transition: all 0.5s;
}

.product {
  position: relative;
  border: 1px solid rgb(100, 16, 173, 0.5);
  border-radius: 10px;
  // margin: 10px;
  overflow: hidden;
  height: 300px;
  width: 370px;
}
.product img {
  transition: all 0.5s;
  height: 300px;
  width: 370px;
}
.product a {
  display: block;
  transition: all 0.5s;
  height: 300px;
  width: 370px;
}
.product .txt {
  position: absolute;
  width: 370px;
  bottom: -55px;
  // left: 15px;
  z-index: 2;
  color: rgb(76, 76, 76);
  text-align: center;
  font-size: 20px;
  font-weight: 700;
}
.product .txt span {
  top: 40px;
  font-size: 16px;
}

.product a:hover .mask {
  opacity: 1;
}
.product a:hover img {
  transform: scale(1.1);
}
.product a:hover .txt {
  transform: translateY(-35px);
  color: white;
}
</style>
